module.exports = Backbone.Model.extend({
	idAttribute: 'name',

	urlRoot: function() {
		return App.deploymentRoot + 'roles'
	}
})
